import { connect } from 'react-redux';
import { ArticleLightView, IArticleLightViewProps } from '../../components/ArticleLightView';
import { IApplicationState } from '../../types/redux';

type TArticleLightViewStateProps = Pick<IArticleLightViewProps, 'contentItem'>;

export function mapStateToProps({ contentItem }: IApplicationState): TArticleLightViewStateProps {
  return {
    contentItem,
  };
}

export const ArticleLightViewContainer = connect(mapStateToProps)(ArticleLightView);
